import styles from './styles.scss';
import cn from 'classnames';
import MainMenuButton from './mainMenuButton';
import { headerConnect as connect } from 'components/Shared/connect';
import { IMainMenu } from 'models/IMainMenu';
import { Search } from 'components/Search';
import MenuItem from './mobileMenuItem';

const MobileMenu = (props: IMainMenu) => (
  <nav className={cn(styles.mainMenu, styles.mobileMenu)}>
    <div className={styles.buttonAndSearchWrapper}>
      <MainMenuButton />
      <Search />
    </div>
    <ul className={cn(styles.categories)}>
      {props.isOpen &&
        props.items.map(item => <MenuItem key={item.id} {...item} parents={[item.id]} />)}
    </ul>
  </nav>
);

export default connect<IMainMenu>(state => ({
  ...state.header.mainMenu
}))(MobileMenu);
